import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../../ts/ServerApi/types/actionParams';

export interface IRunCreateExtractsOnWorkbooksParams extends IMultipleIdsParams {
  dsIds: string[]; // datsource ids
  encrypt: boolean;
}

export class RunCreateExtractsOnWorkbooksRequest extends Request<IRunCreateExtractsOnWorkbooksParams, IResult> {
  constructor(ids: string[], dsIds: string[], encrypt: boolean) {
    super('runCreateExtractsOnWorkbooks', {
      ids: ids,
      dsIds: dsIds,
      encrypt: encrypt

    });
  }
}
